import React, { useState, useEffect } from "react";
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';

function Carrinho() {

    const API_URL = process.env.REACT_APP_IMG_URL;

    const imagemUrl = `${API_URL}/api/images/`;

    const [carrinho, setCarrinho] = useState([]);

    useEffect(() => {
        const carrinhoSalvo = localStorage.getItem("carrinho");
        if (carrinhoSalvo) {
            setCarrinho(JSON.parse(carrinhoSalvo));
        }
    }, []);

    const removerDoCarrinho = (index) => {
        const novoCarrinho = carrinho.filter((_, i) => i !== index);
        setCarrinho(novoCarrinho);
        localStorage.setItem("carrinho", JSON.stringify(novoCarrinho));
    };

    const calcularTotal = () => {
        return carrinho.reduce((total, item) => total + item.preco * item.quantidade, 0).toFixed(2);
    };


    return (
        <React.Fragment>
            <Menu />
            <main className="content">
                <div className="container mt-5">
                    <h1 className="text-center mb-4">🛒 Carrinho de Compras</h1>

                    {carrinho.length === 0 ? (
                        <div className="text-center">
                            <p>Seu carrinho está vazio.</p>
                            <a href="/loja" className="btn btn-primary">Voltar para a Loja</a>
                        </div>
                    ) : (
                        <div className="row">
                            {carrinho.map((produto, index) => (
                                <div key={index} className="col-md-4 mb-4">
                                    <div className="card shadow-sm h-100">
                                        <img
                                            src={imagemUrl + produto.imagen}
                                            className="card-img-top"
                                            alt={produto.nome}
                                            style={{
                                                width: "100%",
                                                height: "150px",
                                                objectFit: "contain",
                                                display: "block",
                                                margin: "auto",
                                            }}
                                        />
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="card-title">{produto.nome}</h5>
                                            <p className="card-text text-muted flex-grow-1">{produto.descricao}</p>
                                            <h4 className="text-primary fw-bold">R$ {produto.preco.toFixed(2)}</h4>
                                            <p className="fw-bold">Quantidade: {produto.quantidade}</p>
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => removerDoCarrinho(index)}
                                            >
                                                ❌ Remover
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {/* Total da compra */}
                <div className="text-center mt-4">
                    <h3>Total: <span className="text-success">R$ {calcularTotal()}</span></h3>
                </div>

                {/* Botão de Checkout */}
                <div className="text-center mt-4">
                    <a href="/checkout" className="btn btn-success btn-lg">💳 Finalizar Compra</a>
                </div>

                <div className="text-center mt-4">
                    <a href="/loja" className="btn btn-secondary">🛍️ Continuar Comprando</a>
                </div>

                {/* Rodape da página */}
                <Footer />
            </main>
        </React.Fragment >
    );
}

export default Carrinho;